<template>
  <div class="invoice">
    <personalHead title="发票" :hide="false" />
    <table width="100%" cellspacing="0" id="table">
      <thead>
        <tr bgcolor="#F5F6F6">
          <td :width="screenWidth>768 ?'15%' : '40%'" >发票信息</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>发票状态</td>
          <td style="color:#67C23A">{{invoiceData.invoice_status|invoiceStatus}}</td>
        </tr>
        <tr>
          <td>发票内容</td>
          <td>商品明细</td>
        </tr>
        <tr>
          <td>发票抬头</td>
          <td>{{invoiceData.custtype|riseStatus}}</td>
        </tr>
      </tbody>
      <tbody v-if="invoiceData.custtype=='01'"> 
        <tr>
          <td>单位名称</td>
          <td>{{invoiceData.custname}}</td>
        </tr>
        <tr>
          <td>纳税人识别号</td>
          <td>{{invoiceData.custTaxNo}}</td>
        </tr>
        <tr>
          <td>注册地址</td>
          <td>{{invoiceData.custAddr}}</td>
        </tr>
        <tr>
          <td>注册电话</td>
          <td>{{invoiceData.custPhone}}</td>
        </tr>
        <tr>
          <td>开户银行</td>
          <td>{{invoiceData.custBank}}</td>
        </tr>
        <tr>
          <td>银行账号</td>
          <td>{{invoiceData.custAccount}}</td>
        </tr>
        <tr>
          <td>备注</td>
          <td>{{invoiceData.invoMemo}}</td>
        </tr>
      </tbody>
    </table>
    <table width="100%" cellspacing="0" id="table">
      <thead>
        <tr bgcolor="#F5F6F6">
          <td align="center">发票代码</td>
          <td align="center">发票号</td>
          <td align="center">微信扫码获取电子普通发票</td>
          <td align="center">下载电子普通发票</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td align="center">{{invoiceData.fpdm}}</td>
          <td align="center">{{invoiceData.fphm}}</td>
          <td align="center">
            <div class="ewm">
              <!-- <span class="common_backgroundImg" :style="'background-image: url('+ewmImg+')'"></span> -->
              <!-- <img :src="{{ewmImg}}" alt="二维码" /> -->
              <img :src="invoiceData.urlQRCode" width="100" height="100" />
              
            </div>
          </td>
          <td>
            <div class="icon">
              <span class="common_backgroundImg"></span>
              <span @click="openTal"  >查看发票</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!--<div class="btn">-->
    <!--<el-button size="mini" round type="danger" @click="sendMailbox">发送邮箱</el-button>-->
    <!--</div>-->
  </div>
</template>

<script>
import personalHead from "@/views/admin/components/personalHead.vue";
import { GetPaymentOrderInvoice } from "@/api/admin/athletes.js";
import { mapGetters } from "vuex";
import QRCodeMy from "@/views/admin/components/QRCode.vue";
export default {
  components: {
    personalHead
  },
  data() {
    return {
      ewmImg: "/image/personal/ewm.png",
      invoice: {},
      invoiceData: {}
    };
  },
  computed: {
    ...mapGetters(["userInfo","screenWidth"])
  },
  created() {
    this.path();
    this.info();
  },
  methods: {
    openTal(){
      window.open(this.invoiceData.invoice_url);
    },
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { path: "/personal", title: "个人中心" },
        {
          path: "/personal/invoiceList",
          title: "发票记录"
        },
        {
          title: "发票详情"
        }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    info() {
      this.invoice.order_sn = this.$route.query.orderSn;
      this.invoice.user_type = this.userInfo.usertype;
      GetPaymentOrderInvoice(Object.assign(this.invoice)).then(data => {
        let list = data.data.result;
        if (list.items.length > 0) {
          this.invoiceData = list.items[0];
         
        }
      });
    },
    // 发送邮件
    sendMailbox() {
      this.$prompt("发送邮箱", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: "邮箱格式不正确",
        inputPlaceholder: "请输入您的邮箱号"
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "你的邮箱是: " + value
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    }
  },
  filters: {
    invoiceStatus: i => {
      switch (i) {
        case "0":
          return "等待开票";
        case "1":
          return "开票成功";
        case "2":
          return "开票失败";
        case "3":
          return "开票失败";
      }
    },
    riseStatus: i => {
      switch (i) {
        case "01":
          return "单位";
        case "03":
          return "个人";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.invoice {
  font-size: 15px;
  #table {
    margin: 20px 0px;
    border-spacing: 0;
    border-collapse: collapse;
    color: #4e4e4e;
    thead {
      tr {
        border: 1px solid #c4c4c4;
        td {
          padding: 15px;
        }
      }
    }
    tbody {
      tr {
        td {
          padding: 15px;
          border: 1px solid #c4c4c4;
        }
        .icon {
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            margin-right: 10px;
          }
          span:nth-child(1) {
            width: 24px;
            height: 24px;
            background-image: url(/image/personal/icon8.png);
          }
          span:nth-child(2) {
            cursor: pointer;
          }
        }
        .ewm {
          span {
            display: inline-block;
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }
  .btn {
    margin: 30px 0px 60px 0px;
  }
}
</style>
